import React from "react";
import { getText } from "../../libs/utils";
import { Box, Button, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { OrderRefresh, OrderTransactopn, OrderReview, CopyIcon, PhotoComplete } from '../../assets/images/icons';
import { styled } from '@mui/material/styles';
import CClipboard from '../../components/CClipboard';

const MyGreyLink = styled(Box)(({ theme }) => ({
  margin: '15px 0 0 20px',
  // [theme.breakpoints.only('md')]: {
  //   marginTop: '0px'
  // },
  // [theme.breakpoints.only('sm')]: {
  //   marginTop: '0px'
  // },
  [theme.breakpoints.only('xs')]: {
    width: '100%',
    textAlign: 'center',
    margin: '7px 0 0'
  }
}))

const GreyBox = styled(Box)(({theme}) => ({
  background: 'rgba(169, 169, 169, 0.05)',
  borderRadius: '11px',
  height: '100%',
  justifyContent: 'center',
  display: 'flex',
  flexFlow: 'column',
  alignItems: 'center',
  minHeight: '300px',
  flex: 1,
  marginTop: '30px',
}));

const OrderDone = ({ order, repeatOrder }) => {

  const reqsList = order.withdrawalTransactions[0] && order.withdrawalTransactions[0].outputs.map((reqs, key) => {
    return <Box key={key} style={{ display: 'flex', alignItems: 'center', margin: '10px 0'}}>
      <Typography variant='orderHash'>
        {reqs.value}
      </Typography>
      <CClipboard text={reqs.value}>
        <Box sx={{ margin: '3px 0 0 15px' }}><CopyIcon width="32" height="32" /></Box>
      </CClipboard>
    </Box>
  })

  return (<Box sx={order.toPaymentSystemType?.value == 'EXTERNAL' ? {display: 'flex', flexDirection: 'column', justifyContent: 'start', height: '100%'} : {}}>
    <Typography variant="h3">{getText('orderHeaderState3')}</Typography>
    <Typography variant="regularCaption">
      {getText('orderDoneSubhed')}
    </Typography>


    {/* COUPON INFO */}
    {reqsList && <>
      <Typography sx={{margin: '30px 0 0'}}>{getText("orderDoneVoucherCaption")}</Typography>
      {reqsList}
      <Typography color="primary.darkRed">{getText("orderDoneVoucherWarn")}</Typography>
    </>}

    <Box sx={{ display: 'flex', gap: { xs: '15px', sm: '10px' }, margin: '30px 0 0', flexWrap: 'wrap' }}>
      <Button
        variant="contained"
        onClick={() => window.open(getText('linkBestchange'), '_blank')}
        size="medium"
        sx={{ padding: '17px 39px', width: { xs: '100%', sm: 'auto' } }}
        className="containedIconLeft"
        startIcon={<OrderReview />}
      >
        {getText('feedbackBtn01')}
      </Button>

      {order.canRepeat && <Button
        size="medium"
        sx={{ padding: '17px 39px', width: { xs: '100%', sm: 'auto' } }}
        startIcon={<OrderRefresh />}
        className="basicIconLeft"
        onClick={repeatOrder}
      >
        {getText('reorderH3')}
      </Button>}

      {order.transactionLink && <Button
        size="medium"
        sx={{ padding: '17px 39px', width: { xs: '100%', sm: 'auto' } }}
        startIcon={<OrderTransactopn />}
        className="basicIconLeft"
        onClick={() => window.open(order.transactionLink, '_blank')}
      >
        {getText('trnsCheckButton')}
      </Button>}

      <MyGreyLink>
        <Typography variant="linkGrey"><Link to="/">{getText('stteBlockMainBtn')}</Link></Typography>
      </MyGreyLink>
    </Box>

    <GreyBox>
      <PhotoComplete />
      <Typography sx={{ display: 'block', color: 'primary.green', fontSize: '12px', marginTop: '20px' }}>{getText('orderProcessed')}</Typography>
    </GreyBox>
  </Box>)
}

export default OrderDone;